import { Link as RLink } from "@tanstack/react-router";
import styled, { css } from "styled-components";
import { colors } from "../assets/themes";
import { Body16 } from "./text";

const StyledLink = styled.a`
  ${({ color, unstyled }) => css`
    color: ${unstyled ? "inherit" : color};
    text-decoration-color: ${unstyled ? "inherit" : color};
    text-decoration: ${unstyled ? "inherit" : undefined};
    &:hover {
      color: ${unstyled ? "inherit" : color};
      text-decoration: ${unstyled ? "inherit" : "underline"};
    }
  `}
`;

const Link = ({
  children,
  href,
  to,
  as,
  onClick,
  color = colors.primary,
  numberOfLines,
  unstyled,
  ...rest
}) => (
  <StyledLink
    as={to ? RLink : as}
    color={color}
    href={href}
    onClick={onClick}
    to={to}
    unstyled={unstyled}
    {...rest}
  >
    <Body16 numberOfLines={numberOfLines} strong>
      {children}
    </Body16>
  </StyledLink>
);

export default Link;
